import { FontSizes, FontWeights } from '@fluentui/theme';
import { mergeStyleSets } from '@fluentui/react';
import { upToMediumScreenSelector } from 'utils/breakpoints';

export const borderStyle = '1px solid #E1DFDD';

const formElement = {
	marginBottom: '1.2rem',
	lineHeight: '1.5',
	marginTop: 0
};

export const stepStyles = mergeStyleSets({
	root: {
		fontSize: FontSizes.size14,
		lineHeight: FontSizes.size20,
		'& p': {
			maxWidth: '550px'
		}
	},
	line: {
		borderBottom: borderStyle,
		maxWidth: '450px',
		margin: '0 0 1rem'
	},
	stretchedContainer: {
		display: 'flex',
		flexDirection: 'column',
		flex: '1 1 auto',
	},
	consentLable: {
		fontSize: FontSizes.size16,
		fontWeight: FontWeights.bold,
		marginBottom: '0.75rem'
	},
	formElement: {
		...formElement
	},
	formInputElement: {
		...formElement,
		maxWidth: '300px'
	},
	button: {
		maxWidth: '310px'
	},
	emphasized: {
		fontWeight: FontWeights.semibold,
		fontSize: FontSizes.size14,
		marginBottom: '1rem'
	},
	progress: {
		maxWidth: '740px'
	},
	groundImg: {
		width: 'calc(100% + 4rem)',
		margin: 'auto -2rem -2rem -2rem',
		paddingTop: '20px',
		selectors: {
			[upToMediumScreenSelector]: {
				width: 'calc(100% + 3rem)',
				margin: 'auto -1.5rem -1.5rem -1.5rem',
			}
		}
	},
	smallGroundImg: {
		paddingTop: '20px',
		width: '80%',
		marginLeft: '5%',
		marginTop: 'auto'
	}
});
